module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "45px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Ryan M Love was born in Kent. Following an education in horticulture, he worked principally as a gardener until a keen interest in modern military history inspired him to begin writing fiction. Having a passion for the outdoor life, he is an avid mountain biker, snowboarder and trail runner. He currently lives in Wales, just outside the Brecon Beacons National Park.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0